<template>
	<div>
		<v-overlay :value="isReloadingAccordi">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>
		
		<v-data-table
			:headers="headersToShow"
			:items="accordi"
			:search="search"
			:loading="isLoading"
			:footer-props="{
				'items-per-page-options': [5, 10, 25, 50, 100, -1]
			}"
			:items-per-page="50"
			:height="dataTableHeight"
			fixed-header
			multi-sort
		>
			<template v-slot:item.quali_aggiornamenti_ci_sono_nelle_pratiche="{ item }">
				<div class="d-flex align-center">
					<v-icon
						v-if="item.quali_aggiornamenti_ci_sono_nelle_pratiche.ci_sono_aggiornamenti_per_account_manager"
						color="pink lighten-1"
						class="mr-1"
					>
						mdi-circle
					</v-icon>
					<v-icon
						v-if="item.quali_aggiornamenti_ci_sono_nelle_pratiche.ci_sono_aggiornamenti_fasi"
						color="secondary"
					>
						mdi-circle
					</v-icon>
				</div>
			</template>
			
			<template v-slot:item.importo_totale_da_fatturare_esiti_provvisori="{ item }">
				{{ item.importo_totale_da_fatturare_esiti_provvisori?.toFixed(2).replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_totale_bonus_esiti_provvisori="{ item }">
				{{ item.importo_totale_bonus_esiti_provvisori?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_totale_da_fatturare_esiti_definitivi="{ item }">
				{{ item.importo_totale_da_fatturare_esiti_definitivi?.toFixed(2).replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_totale_bonus_esiti_definitivi="{ item }">
				{{ item.importo_totale_bonus_esiti_definitivi?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.notes="{ item }">
				<span
					class="d-inline-block text-truncate"
					style="max-width: 150px; cursor: pointer"
					@click="openNotesDialog(item)"
				>
					{{ item.notes || '------' }}
				</span>
			</template>
			<template v-slot:item.account_manager="{ item }">
				{{ item.account_manager.nome }} {{ item.account_manager.cognome}}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openAccordoDialog('edit', item)"
					>
						mdi-pencil
					</v-icon>
				</v-hover>
				
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openAccordoDialog('show', item)"
					>
						mdi-text-box-search-outline
					</v-icon>
				</v-hover>
				
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openPraticaDialog('store', item)"
					>
						mdi-plus
					</v-icon>
				</v-hover>
				
				<v-hover v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openCoppieAsseRegioneDialog(item)"
					>
						mdi-checkbox-multiple-blank-circle
					</v-icon>
				</v-hover>
				
				<v-btn
					color="tertiary"
					@click="openPraticheDataTableDialog(item.id)"
					:disabled="isLoading"
					class="black--text mr-2"
					small
				>
					Pratiche
				</v-btn>
				
				<v-hover
					v-if="isAccountManager"
					v-slot="{ hover }"
				>
					<v-icon
						:class="`${hover ? 'error--text' : ''}`"
						size="20"
						@click="openDeleteAccordoDialog(item)"
					>
						mdi-delete-forever
					</v-icon>
				</v-hover>
			</template>
			
			<template v-slot:footer.prepend>
				<div class="d-flex align-center">
					<v-btn
						@click="openHideShowHeadersDialog()"
						color="secondary"
						class="ml-md-auto mr-3 white--text"
						depressed
					>
						<v-icon small>mdi-minus</v-icon>
						<v-icon>mdi-view-column-outline</v-icon>
						<v-icon small>mdi-plus</v-icon>
					</v-btn>
					
					<v-btn
						color="secondary"
						class="white--text"
						@click="downloadCsvColonneVisibili()"
						:disabled="isLoading"
					>
						Scarica CSV colonne visibili
					</v-btn>
				</div>
			</template>
		</v-data-table>
		
		<v-dialog
			:value="showAccordoDialog"
			persistent
			max-width="800"
		>
			<store-edit-view-accordo
				:key="accordoKey"
				v-model="accordo"
				:action="action"
				:search="search"
				:cliente-id="clienteId"
				@close="showAccordoDialog = false"
				@reload-accordi="getAccordi(true)"
			></store-edit-view-accordo>
		</v-dialog>
		
		<v-dialog
			:value="showPraticaDialog"
			persistent
			scrollable
		>
			<store-edit-view-pratica
				:key="praticaKey"
				v-model="pratica"
				:accordo="accordo"
				:fasi-with-stati="fasiWithStati"
				:action="action"
				@close="showPraticaDialog = false"
				@reload-accordi="reloadAccordi(true)"
			></store-edit-view-pratica>
		</v-dialog>
		
		<v-dialog
			v-model="showPraticheDataTableDialog"
			scrollable
			persistent
		>
			<v-card>
				<v-card-title class="text-h5">
					Pratiche dell'Accordo
				</v-card-title>
				
				<v-card-text>
					<pratiche
						:key="praticheKey"
						:accordo-id="accordoId"
						:cliente-id="clienteId"
						@reload-accordi="reloadAccordi()"
					></pratiche>
				</v-card-text>
				
				<!--<v-divider></v-divider>-->
				
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						@click="showPraticheDataTableDialog = false"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="notesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<accordo-notes
				:key="notesKey"
				v-model="accordoForNotes"
				@close="notesDialog = false"
				@accordo-updated="updateAccordoObject($event)"
			></accordo-notes>
		</v-dialog>
		
		<v-dialog
			v-model="filtersDialog"
			scrollable
			persistent
			width="800px"
		>
			<accordi-filters
				:key="accordiFiltersKey"
				ref="accordiFilters"
				:hide-clienti-filter="accordoId !== null"
				@close="filtersDialog = false"
				@reload-accordi="reloadAccordi()"
			></accordi-filters>
		</v-dialog>
		
		<v-dialog
			v-model="hideShowHeadersDialog"
			width="unset"
		>
			<v-card>
				<v-card-title>
					<span class="mr-1">Mostra/nascondi colonne</span>
					<v-spacer></v-spacer>
					<v-icon @click="hideShowHeadersDialog = false">mdi-close</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet
						outlined
						rounded
						class="py-3"
					>
						<v-treeview
							:items="headersToFilter"
							item-key="value"
							item-text="text"
							v-model="selectedHeaders"
							selected-color="primary"
							selectable
							dense
							open-all
						>
						</v-treeview>
					</v-sheet>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<!-- DELETE ACCORDO -->
		<v-dialog
			:value="deleteAccordoDialog"
			persistent
			max-width="600px"
		>
			<v-card>
				<v-card-title class="text-h5">
					Vuoi eliminare l'accordo {{ accordoToDelete?.custom_id }}?
				</v-card-title>
				<v-card-text>
					<span class="font-weight-medium">Ragione Sociale Cliente: </span>
					<span class="secondary--text">{{ accordoToDelete?.cliente.ragione_sociale }}</span>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="deleteAccordoDialog = false"
						:disabled="isDeletingAccordo"
						class="black--text"
					>
						Annulla
					</v-btn>
					<v-btn
						color="error"
						@click="deleteAccordo()"
						:loading="isDeletingAccordo"
						:disabled="isLoading || isDeletingAccordo"
					>
						Elimina
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			:value="coppieAsseRegioneDialog"
			persistent
		>
			<coppie-asse-regione
				:key="coppieAsseRegioneKey"
				v-model="accordo"
				@close="coppieAsseRegioneDialog = false"
			></coppie-asse-regione>
		</v-dialog>
		
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
	props: [
		'search',
		'clienteId', // dialog con gli accordi di un cliente
		// 'accountManagersIds'
	],
	data() {
		return {
			isLoading: false,
			isReloadingAccordi: false,
			
			headers: [
				{ text: 'ID', value: 'custom_id' },
				{ text: 'Bando', value: 'bando.nome' },
				{ text: 'Tipologia', value: 'cliente.tipologia' },
				{ text: 'Codice Cliente', value: 'cliente.codice_cliente' },
				{ text: 'Ragione sociale', value: 'cliente.ragione_sociale' },
				{ text: 'Nome Cliente', value: 'cliente.nome' },
				{ text: 'Cognome Cliente', value: 'cliente.cognome' },
				{ text: 'Nome Referente', value: 'nome_referente' },
				{ text: 'Cognome Referente', value: 'cognome_referente' },
				{ text: 'Email Referente', value: 'email_referente' },
				{ text: 'Numero pratiche', value: 'numero_pratiche' },
				{ text: 'Pratiche Vincenti', value: 'pratiche_vincenti_count' },
				{ text: 'Link Affare', value: 'link_affare' },
				{ text: 'Attività', value: 'quali_aggiornamenti_ci_sono_nelle_pratiche', sortable: false },
				{ text: 'Note Accordo', value: 'notes' },
				{ text: 'Imponibile Totale da Fatturare Esiti Provvisori', value: 'importo_totale_da_fatturare_esiti_provvisori' },
				{ text: 'Imponibile Totale Bonus Esiti Provvisori', value: 'importo_totale_bonus_esiti_provvisori' },
				{ text: 'Imponibile Totale da Fatturare Esiti Definitivi', value: 'importo_totale_da_fatturare_esiti_definitivi' },
				{ text: 'Imponibile Totale Bonus Esiti Definitivi', value: 'importo_totale_bonus_esiti_definitivi' },
				{ text: 'Account Manager', value: 'account_manager' },
				// questi due servono a far funzionare la ricerca sul nome e il cognome dell'account manager
				{ text: 'Nome Account Manager', value: 'account_manager.nome', class: 'd-none', cellClass: 'd-none' },
				{ text: 'Cognome Account Manager', value: 'account_manager.cognome', class: 'd-none', cellClass: 'd-none' },
				{ text: 'Azioni', value: 'actions', sortable: false, width: '270px' },
			],
			accordi: [],
			
			action: null,
			
			accordoKey: 0,
			showAccordoDialog: false,
			accordo: null,
			
			praticaKey: 0,
			showPraticaDialog: false,
			pratica: null,
			
			praticheKey: 0,
			accordoId: null,
			showPraticheDataTableDialog: false,
			
			notesKey: 0,
			accordoForNotes: null,
			notesDialog: false,
			
			accordiFiltersKey: 0,
			filtersDialog: false,
			
			hideShowHeadersDialog: false,
			selectedHeaders: [],
			
			accordoToDelete: null,
			deleteAccordoDialog: false,
			isDeletingAccordo: false,
			
			coppieAsseRegioneKey: 0,
			coppieAsseRegioneDialog: false
		}
	},
	
	created() {
		this.getAccordi();
		
		// recupero dal localStorage le colonne che si è scelto di mostrare nella tabella
		if (localStorage.getItem('selected_accordi_headers_manager_clickday')) {
			this.selectedHeaders = JSON.parse(localStorage.getItem('selected_accordi_headers_manager_clickday'));
		}
		else {
			this.selectedHeaders = this.headers.map(header => (header.value));
			localStorage.setItem('selected_accordi_headers_manager_clickday', JSON.stringify(this.selectedHeaders));
		}
	},
	
	watch: {
		selectedHeaders(newHeaders) {
			localStorage.setItem('selected_accordi_headers_manager_clickday', JSON.stringify(newHeaders));
		}
	},
	
	computed: {
		...mapGetters({
			fasiWithStati: 'fasi/fasiWithStati',
			isAccountManager: 'auth/isAccountManager',
			conAggiornamentiNellePratiche: 'accordiFilters/conAggiornamentiNellePratiche',
			accountManagersIds: 'sharedFilters/accountManagersIds'
		}),
		computedAccountManagersIds() {
			return this.accountManagersIds.value;
		},
		headersToFilter() {
			return [{
				value: 'headers',
				text: 'Tutte',
				children: this.headers.flatMap(header => {
					if (header.value !== 'actions'
						&& header.value !== 'account_manager.nome'
						&& header.value !== 'account_manager.cognome'
					) {
						return {
							value: header.value,
							text: header.text
						}
					}
					else return [];
				})
			}]
		},
		headersToShow() {
			return this.headers.filter(header => this.selectedHeaders.includes(header.value) || header.value == 'actions')
		},
		dataTableHeight() {
			// dialog con gli accordi di un cliente
			if (this.clienteId) return 'calc(100vh - 350px)';
			else return 'calc(100vh - 207px)'
		}
	},
	
	methods: {
		...mapActions({
			showSnackbar: 'systemSnackbar/show'
		}),
		getAccordi() {
			this.isLoading = true;
			this.$emit('is-loading', true);
			return axios.get('/api/accordi', {
				params: {
					cliente_id: this.clienteId,
					conAggiornamentiNellePratiche: this.conAggiornamentiNellePratiche.value,
					accountManagersIds: this.computedAccountManagersIds
				}
			})
				.then(response => {
					this.accordi = response.data;
				})
				.finally(() => {
					this.isLoading = false;
					this.$emit('is-loading', false);
				})
		},
		async reloadAccordi() {
			this.isReloadingAccordi = true;
			if (this.clienteId) this.$emit('reload-clienti');
			await this.getAccordi();
			this.isReloadingAccordi = false;
		},
		openAccordoDialog(action, accordo = null) {
			this.accordo = accordo;
			this.action = action;
			this.accordoKey++;
			this.showAccordoDialog = true;
		},
		openPraticaDialog(action, accordo, pratica = null) {
			this.action = action;
			this.accordo = accordo;
			this.pratica = pratica;
			this.praticaKey++;
			this.showPraticaDialog = true;
		},
		openPraticheDataTableDialog(accordoId) {
			this.accordoId = accordoId;
			this.praticheKey++;
			this.showPraticheDataTableDialog = true;
		},
		openCoppieAsseRegioneDialog(accordo) {
			this.accordo = accordo;
			this.coppieAsseRegioneKey++;
			this.coppieAsseRegioneDialog = true;
		},
		openNotesDialog(accordo) {
			this.notesKey++;
			this.accordoForNotes = accordo;
			this.notesDialog = true;
		},
		updateAccordoObject(data) {
			let accordoAggiornato = data.accordoAggiornato;
			Object.assign(this.accordi?.find(accordo => accordo.id == accordoAggiornato.id), accordoAggiornato);
		},
		openAccordiFilters() {
			this.filtersDialog = true;
		},
		openHideShowHeadersDialog() {
			this.hideShowHeadersDialog = true;
		},
		openDeleteAccordoDialog(pratica) {
			this.accordoToDelete = pratica;
			this.deleteAccordoDialog = true;
		},
		deleteAccordo() {
			this.isDeletingAccordo = true;
			axios.delete(`/api/accordi/${this.accordoToDelete.id}`)
				.then(response => {
					this.deleteAccordoDialog = false;
					this.deleteAccordoFromDataObject(this.accordoToDelete.id);
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
				})
				.finally(() => {
					this.isDeletingAccordo = false;
				})
		},
		deleteAccordoFromDataObject(id) {
			this.$delete(this.accordi, this.accordi.findIndex((accordo) => accordo.id == id));
		},
		downloadCsvColonneVisibili() {
			// 1. Header realmente mostrati in tabella, escluse colonne da ignorare
			const headersCsv = this.headersToShow
				.filter(header => 
					header.value !== 'actions' && 
					header.value !== 'quali_aggiornamenti_ci_sono_nelle_pratiche' &&
					header.value !== 'account_manager.nome' &&
					header.value !== 'account_manager.cognome'
				);
			
			// 2. Trasformo ogni riga della tabella in un oggetto pronto per il CSV
			const rows = this.accordi.map(accordo => {
				const row = {};
				headersCsv.forEach(header => {
					// Gestione speciale per Account Manager (combino nome e cognome)
					if (header.value === 'account_manager') {
						const nome = accordo.account_manager?.nome || '';
						const cognome = accordo.account_manager?.cognome || '';
						row[header.text] = `${nome} ${cognome}`.trim();
					}
					// sostituisco il punto con la virgola per i valori numerici in formato stringa
					else if (header.value === 'importo_totale_da_fatturare_esiti_provvisori') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(accordo, header.value)?.toFixed(2).replace('.', ',');
					else if (header.value === 'importo_totale_bonus_esiti_provvisori') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(accordo, header.value)?.replace('.', ',');
					else if (header.value === 'importo_totale_da_fatturare_esiti_definitivi') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(accordo, header.value)?.toFixed(2).replace('.', ',');
					else if (header.value === 'importo_totale_bonus_esiti_definitivi') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(accordo, header.value)?.replace('.', ',');
					
					else row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(accordo, header.value);  // la chiave è il label visibile, non il path
					
				});
				return row;
			});
			
			// 3. Creo il CSV
			let csv = this.$papa.unparse(rows, {
				delimiter: ';',
				header: true,
				columns: headersCsv.map(header => header.text) // ordine colonne = ordine header corrente
			});
			
			// Prepend BOM (risolve problemi di codifica)
			csv = '\uFEFF' + csv;
			
			// 4. Download
			this.$papa.download(csv, 'accordi');
		},
	}
}
</script>

<style scoped>

</style>